module.exports = __webpack_public_path__ + "img/filters-ductwork-cleaned-02-large.0da516f0.jpg";